// 등기부 일괄발급 API 상수
// 가변 path (batchId, itemSeq) 는 action 에서 템플릿으로 조립
const BASE = "/api/v1/registry-batch/admin";

export default {
  BASE,
  UPLOAD: `${BASE}/upload`,
  // NZSC-2697 — 폴리곤 기반 일괄발급 entry (beaver 연동)
  POLYGON_UPLOAD: `${BASE}/polygon/upload`,
  LIST: `${BASE}/list`,
  DETAIL: batchId => `${BASE}/${batchId}`,
  SUMMARY: batchId => `${BASE}/${batchId}/summary`,
  DOWNLOAD_URL: batchId => `${BASE}/${batchId}/download-url`,
  ISSUE_CONFIRM: batchId => `${BASE}/${batchId}/issue-confirm`,
  PATCH_ITEM: (batchId, itemSeq) => `${BASE}/${batchId}/items/${itemSeq}`,
  RE_SEARCH: (batchId, itemSeq) => `${BASE}/${batchId}/items/${itemSeq}/re-search`,
  SELECT_CANDIDATE: (batchId, itemSeq) => `${BASE}/${batchId}/items/${itemSeq}/select-candidate`,
  SET_UNIQUE_NO: (batchId, itemSeq) => `${BASE}/${batchId}/items/${itemSeq}/set-unique-no`,
  // NZSC-2827 — PDF 없는 건(FAILED/SEARCHED) 한꺼번에 재발급 (중단 복구)
  RESUME_ISSUE: batchId => `${BASE}/${batchId}/resume-issue`,
  // NZSC-2827 — 단건 재발급 (FAILED + uniqueNo 있는 건만)
  RE_ISSUE: (batchId, itemSeq) => `${BASE}/${batchId}/items/${itemSeq}/re-issue`,
};
